if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(function (registrations) {
    const registrationslength = registrations.length;
    for (let i = 0; i < registrationslength; i += 1) {
        registrations[i].unregister();
    }
  });
}
